import { animate } from "motion"

const btn = document.querySelector<HTMLButtonElement>("[data-nav-toggle]")
let menu = document.getElementById("mobile-menu")

const swapIcons = (open: boolean) => {
	const menuIcon = btn?.querySelector('[data-icon="menu"]') as HTMLElement | null
	const closeIcon = btn?.querySelector('[data-icon="close"]') as HTMLElement | null
	if (open) {
		menuIcon?.classList.add("hidden")
		closeIcon?.classList.remove("hidden")
	} else {
		closeIcon?.classList.add("hidden")
		menuIcon?.classList.remove("hidden")
	}
}

const buildLinksHtml = () => {
	const links = Array.from(document.querySelectorAll("#site-nav a"))
	const path = window.location.pathname.replace(/\/$/, "") || "/"
	return links
		.map(a => {
			const anchor = a as HTMLAnchorElement
			const hrefAttr = anchor.getAttribute("href") || "#"
			const label = anchor.textContent || ""
			const isActive = new URL(anchor.href).pathname.replace(/\/$/, "") === path
			return `<a href="${hrefAttr}" class="text-2xl">${label}</a>${isActive ? '<i class="bg-primary block h-0.5 w-24"></i>' : ""}`
		})
		.join("")
}

const getMenu = () => (menu = document.getElementById("mobile-menu"))

const openMobile = () => {
	const el = getMenu()
	if (!el) return
	el.classList.remove("hidden", "pointer-events-none")
	swapIcons(true)
	btn?.setAttribute("aria-expanded", "true")
	animate(el, { opacity: [0, 1], transform: ["translateY(0.5rem)", "translateY(0)"] } as any, { duration: 0.3 })
}

const closeMobile = () => {
	if (!menu) return
	swapIcons(false)
	btn?.setAttribute("aria-expanded", "false")
	animate(menu, { opacity: [1, 0], transform: ["translateY(0)", "translateY(0.5rem)"] } as any, {
		duration: 0.25
	}).finished.then(() => {
		menu?.classList.add("hidden")
		menu?.classList.add("pointer-events-none")
	})
}

btn?.addEventListener("click", () => {
	const isOpen = btn.getAttribute("aria-expanded") === "true"
	isOpen ? closeMobile() : openMobile()
})

document.addEventListener("click", e => {
	const target = e.target as Element | null
	if (target && target.matches("[data-nav-close]")) {
		closeMobile()
	}
	if (target && target.closest("#mobile-menu") && target instanceof HTMLAnchorElement) {
		closeMobile()
	}
})

const mq = window.matchMedia("(min-width: 768px)")
const handle = () => {
	if (mq.matches) closeMobile()
}
handle()
mq.addEventListener?.("change", handle)
